import * as React from 'react';

export interface ICaseNumberControlProps {
    onChange: (value: string) => void;
    readonly?: boolean;
    value: string | undefined;
}

export function CaseNumberControl(props: ICaseNumberControlProps) {
    const [localValue, setLocalValue] = React.useState<string>(props.value ?? '');

    return (
        <input
            className="form-control"
            type="text"
            name="caseNumber"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={() => props.onChange(localValue)}
            style={{ width: 'auto' }}
            disabled={props.readonly}
        />
    );
}
